import { gql } from "@apollo/client"
import {
  INWARD_QUALITY_FRAG,
  TRIP_DETAIL_FRAG,
} from "./inwarding.fragments.gql"
import { TRANSPORT_DETAIL_FRAG } from "../scheduling/scheduling.fragments.gql"
import { QUALITY_BASE_FRAG } from "graphql/quality.gql"

// Queries
const TRIPS_FOR_DATE = gql`
  query TripsForDate($date: Date!, $query: String, $first: Int, $skip: Int) {
    tripsForDate(
      date: $date
      query: $query
      first: $first
      skip: $skip
      isWholesale: false
    ) {
      id
      uuid
      status
      weighDetail {
        id
        status
      }
      aggregator {
        id
        fullName
      }
      vehicle {
        id
        registrationNumber
      }
      bookings {
        id
        procuredQuantity
        qualitySample {
          ...QualityBaseFrag
        }
        inwards {
          id
          serialNo
          rstNo
          statusLogs(status: "CMP") {
            createdBy {
              id
              fullName
            }
          }
          weigh {
            id
            status
            inwardedQuantity
          }
          ...InwardQualityFrag
        }
        schedule {
          id
          gatelogsSet {
            id
            createdAt
            gateEntryNo
            gateStatus
            gateNumber {
              id
              name
              codename
            }
          }
          plot {
            id
            farmer {
              id
              fullName
              isBlocked
              companies {
                id
              }
            }
          }
          skuType {
            id
            name
          }
          gatePass
        }
      }
    }
  }
  ${INWARD_QUALITY_FRAG}
  ${QUALITY_BASE_FRAG}
`

const BACKEND_TRIP_DETAILS = gql`
  query BackendTripDetails($id: Int, $uuid: String) {
    tripDetails(tripId: $id, uuid: $uuid) {
      ...TripDetailFrag
    }
  }
  ${TRIP_DETAIL_FRAG}
`

const TRIP_WEIGH_STATUS = gql`
  query tripWeighStatus($id: Int) {
    tripDetails(tripId: $id) {
      weighDetail {
        id
        status
      }
      bookings {
        id
        inwards {
          id
          weigh {
            id
            status
          }
        }
      }
    }
  }
`

const BOOKING_QUALITY = gql`
  query bookingQuality($id: Int) {
    bookingDetails(id: $id) {
      id
      inwards {
        ...InwardQualityFrag
      }
    }
  }
  ${INWARD_QUALITY_FRAG}
`

const INWARD_SUMMARY_FOR_DATE = gql`
  query inwardSummaryForDate($date: Date) {
    inwardedSummary(date: $date) {
      scheduledTrips
      inwardedTrips
      inwardedBookings
      scheduledBookings
      inwardedQuantity
      scheduledQuantity
      netWeight
      grossWeight
      acceptedWeight
      rejectedWeight
      averageQualityRejection
      averageStandardRejection
    }
  }
`

export const BOOKING_INFO = gql`
  query BookingInfo($scheduleId: ID!, $schedule: Int) {
    transportDetail(schedule: $schedule) {
      ...TransportDetailFrag
    }
    scheduleDetails(scheduleId: $scheduleId) {
      id
      date
      gatePass
      cropGroup {
        id
        name
        codename
      }
      assignedPoCodes
      aggregator {
        id
        fullName
      }
      vehicle {
        id
        driver {
          id
          fullName
        }
        registrationNumber
        vehicleType {
          id
          name
        }
      }
      sourceDepot {
        id
        name
      }
      destinationDepot {
        id
        name
      }
      company {
        id
        name
        codename
      }
      variety {
        id
        name
        commodity {
          id
          name
        }
      }
      requiredQuantity
      skuType {
        id
        name
      }
      plot {
        farmer {
          id
          fullName
          companyCode
        }
        id
        address {
          id
          village
          taluka
          district
        }
      }
      plotCommodity {
        id
        name
        registrationCode
        agronomist {
          id
          fullName
        }
      }
      scheduleRequest {
        id
        timeSlot {
          id
          demand {
            id
            name
          }
        }
      }
    }
  }
  ${TRANSPORT_DETAIL_FRAG}
`
export {
  TRIP_WEIGH_STATUS,
  BACKEND_TRIP_DETAILS,
  TRIPS_FOR_DATE,
  BOOKING_QUALITY,
  INWARD_SUMMARY_FOR_DATE,
}
